export default __webpack_public_path__ + "static/media/section3.766fe95d.png";